// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"276ee2d2","453":"e407875d"}[chunkId] + ".chunk.js";
};